/**
 * Created by simon zhao on 09/01/2021.
 * Description:
 * responsible for keeping the state for both task kanban view and instance kanban view.
 * ------ maintenance history ------
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { GridLayoutModel } from '../instance-view/grid-layout.model';

@Injectable()
export class WorkflowKanbanScreenStateService {
    /**
     * the id of the task selected in the task kanban view.
     *
     * @type {string}
     * @memberof WorkflowKanbanScreenStateService
     */
    selectedTaskId: string;

    /**
     * the id of the instance selected in the instance kanban view.
     *
     * @type {string}
     * @memberof WorkflowKanbanScreenStateService
     */
    selectedInstanceId: string;

    /**
     * This subject is used to notify related components to refresh when data is updated.
     *
     *
     * @memberof WorkflowKanbanScreenStateService
     */
    refreshSubject$ = new Subject();

    /**
     * The identity of current workflow kanban screen.
     */
    screenId: string;
}
